import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { VersioneFuturaDTO } from "../dto/versione-futuraDTO";
import { VersioneFuturaVO } from "../vo/versione-futuraVO";

@Injectable({
  providedIn: "root"
})
export class MapperVersioneFutura
  implements MapperInterface<VersioneFuturaDTO, VersioneFuturaVO> {
  constructor() { }

  convertVoToDto(vo: VersioneFuturaVO): VersioneFuturaDTO {
    if (vo != null) {
      const dto = new VersioneFuturaDTO();

      dto.codice = vo.codice;
      dto.nome = vo.nome;
      dto.id = vo.id;
      dto.dataInizioValidita = vo.dataInizioValidita;
      dto.dataFineValidita = vo.dataFineValidita;
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: VersioneFuturaDTO): VersioneFuturaVO {
    if (dto != null) {
      const vo = new VersioneFuturaVO();

      vo.id = dto.id;
      vo.nome = dto.nome;
      vo.codice = dto.codice;
      vo.dataInizioValidita = dto.dataInizioValidita;
      vo.dataFineValidita = dto.dataFineValidita;
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(
    autorizzazioneVOList: VersioneFuturaVO[]
  ): VersioneFuturaDTO[] {
    const autorizzazioneDTOList = new Array<VersioneFuturaDTO>();
    autorizzazioneVOList.forEach(vo => {
      autorizzazioneDTOList.push(this.convertDtoToVo(vo));
    });

    return autorizzazioneDTOList || new Array<VersioneFuturaDTO>();
  }

  convertListDtoToVo(
    autorizzazioneDTOList: VersioneFuturaDTO[]
  ): VersioneFuturaVO[] {
    const autorizzazioneVOList = new Array<VersioneFuturaVO>();
    autorizzazioneDTOList.forEach(dto => {
      autorizzazioneVOList.push(this.convertDtoToVo(dto));
    });

    return autorizzazioneVOList || new Array<VersioneFuturaVO>();
  }
}
